import type { DecisionEngineDestinationUI } from "./definition";

export const oneSignalUI: DecisionEngineDestinationUI = {
  campaignSetup: "resource",
  resourceName: "template",
  channelDescription: "OneSignal",
  getReferenceString: (s) => `{{ ${s} }}`,
  isInactive: () => false,
  isPreviewSupported: true,
  getTemplateResourceType: ({ type }) => `${type}-template`,
  getResourceType: ({ type }) => `${type}-template`,
  getEmailPreviewMethod: "preview",
  isTestSendSupported: true,
  showIdentifierField: true,
};

const VARIABLE_REFERENCE_PREFIX = "hightouch.recommendation.variables.";

/**
 * Must stay in sync with `toOneSignalVariableTagKey` in
 * packages/backend/lib/customer-data/decision-engine/destination-definitions/one-signal.ts
 * (the in-app sync config generator). Each message variable becomes its own
 * flat `aid_var_*` user tag because OneSignal IAM personalization can't read
 * the usual `hightouch` JSON blob, and keys avoid characters outside
 * [a-z0-9_] because dotted keys break IAM tag substitution.
 */
const toOneSignalVariableTagKey = (variableName: string) =>
  `aid_var_${variableName.toLowerCase().replace(/[^a-z0-9_]/g, "_")}`;

/**
 * OneSignal in-app messages have no listing/fetch API — they are built in the
 * OneSignal dashboard and referenced here by a pasted identifier, which the
 * sync writes to each enrolled user as the `aid_iam_campaign` tag the
 * customer's IAM segment targets.
 */
export const oneSignalInAppUI: DecisionEngineDestinationUI = {
  campaignSetup: "freeform",
  resourceName: "in-app message",
  channelDescription: "OneSignal (In-App)",
  getReferenceString: (reference) => {
    const name = reference.startsWith(VARIABLE_REFERENCE_PREFIX)
      ? reference.slice(VARIABLE_REFERENCE_PREFIX.length)
      : reference;
    return `{{ ${toOneSignalVariableTagKey(name)} }}`;
  },
  isPreviewSupported: false,
  isTestSendSupported: false,
};
